import { getLocale } from './index.js'
import React, { useState }  from 'react' //eslint-disable-line
// 国际化，获取语言类型
// let lang = window.localStorage.getItem('localLanguage')
//   || window.navigator.language
//   || window.navigator.userLanguage
// lang = lang.split('-')[0]
const useLang = () => {
  const [lang, setLang] = useState(getLocale())
  function changeLang(newLang: string): void {
    setLang(newLang)
    const urlList: string[] = window.location.href.split('?')
    const url: string = urlList[0]
    const query: string = urlList[1]
    if (query && query.split('&').length > 1) {
      const urlWithQuery = window.location.href.split('&')[0]
      window.location.replace(`${urlWithQuery}&locale=${newLang}`)
    } else {
      window.location.replace(`${url}?locale=${newLang}`)
    }
    // document.title = newLang === 'zh' ? '小米信任中心' : 'Xiaomi Trust Center'
    // window.location.reload()
  }
  return [lang, changeLang]
}

export default useLang
// let lang1 = getLocale('locale')
// let lang = getLocale()
// 保存语言类型
// window.localStorage.setItem('localLanguage', lang)


// const setLang = newLang => {
//   // window.localStorage.setItem('localLanguage', newLang)
// const url = window.location.href.split('?')[0]
//   lang = newLang
//   window.location.replace(`${url}?locale=${newLang}`)
//   window.location.reload()
// }

// export { lang, setLang }
